import { ADMIN_MUTATION_TYPES } from "../../mutation-types";

/**
 * Admin mutations
 */

const mutations = {
  /**
   * Save the users under the Ports
   * @param {*} state
   * @param {*} users
   */

  [ADMIN_MUTATION_TYPES.SAVE_PORT_USERS](state, users) {
    state.allUsersForPort = users;
  },
  /**
   * Save the users under the NIMASA Admin
   * @param {*} state
   * @param {*} users
   */

  [ADMIN_MUTATION_TYPES.SAVE_NIMASA_ADMIN_USERS](state, users) {
    state.allUsersForNimasaAdmin = users;
  },
  /**
   * Save the users under the NIMASA Agent
   * @param {*} state
   * @param {*} users
   */

  [ADMIN_MUTATION_TYPES.SAVE_NIMASA_USERS](state, users) {
    state.allUsersForNimasaAgent = users;
  },
  /**
   * Save the users under the NIMASA Managers
   * @param {*} state
   * @param {*} users
   */

  [ADMIN_MUTATION_TYPES.SAVE_NIMASA_MANAGER_USERS](state, users) {
    state.allUsersForNimasaManager = users;
  }
};

export default mutations;
